const timelines = document.querySelectorAll('.timeline');
if(timelines) {
    window.addEventListener('load', () => {
        timelineEntriesInViewport();
    })
    window.addEventListener('scroll', function() {
        timelineEntriesInViewport();
    });
}

function timelineEntriesInViewport() {
    timelines.forEach(timeline => {
        let entries = timeline.querySelectorAll('article');
        entries.forEach(entry => {
            if(inViewport(entry)) {
                entry.classList.add('active');
            } else {
                entry.classList.remove('active');
            }
        });
    })
}